import {
  LOGIN_USER,
  LOGOUT_USER
} from '../actions';

const INIT_STATE = {
  userAdmin: JSON.parse(localStorage.getItem('user_admin'))
};

global.user = INIT_STATE;

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, userAdmin: action.payload };
    case LOGOUT_USER:
      return { ...state ,userAdmin: null};
    default: return { ...state };
  }
}
